import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SuccessCup(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "SuccessCup", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m28 27.9898 1.4788-.0636c6.5802-.2831 10.3764-1.7248 12.3082-4.6749 1.4085-2.1503 1.5903-4.6733.4865-6.7488-1.0552-1.9845-3.0619-3.1415-5.5054-3.1743-.0518-.0008-.1036-.0011-.1548-.0011-4.3356 0-6.0961 2.4719-6.1698 2.5784l-.1394.2016L28 27.9898Zm8.6122-12.3264c.0413 0 .0825.0002.1247.0009 1.5649.0209 2.8312.7263 3.4741 1.9351.6972 1.3114.556 2.9457-.3782 4.3719-.8535 1.303-2.714 3.0374-8.9707 3.5312l1.6311-8.4121c.3893-.4043 1.6213-1.427 4.119-1.427ZM19.989 27.9898l-1.4788-.0636c-6.5802-.2831-10.37634-1.7248-12.30822-4.6749-1.40847-2.1503-1.59025-4.6733-.48649-6.7488 1.05525-1.9845 3.06195-3.1415 5.50551-3.1743.0517-.0008.1035-.0011.1548-.0011 4.3355 0 6.096 2.4719 6.1697 2.5784l.1393.2016 2.3042 11.8827Zm-8.6122-12.3264c-.0413 0-.0825.0002-.1246.0009-1.56493.0209-2.83123.7263-3.47414 1.9351-.69725 1.3114-.55604 2.9457.37819 4.3719.85348 1.303 2.71395 3.0374 8.97065 3.5312l-1.6312-8.4121c-.3891-.4043-1.6212-1.427-4.1189-1.427Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.1068 10.2305h-26.215S8.27501 24.6593 21.9536 30.2821h4.0914c13.6785-5.6228 11.0618-20.0516 11.0618-20.0516ZM29.0103 37.858c-3.3051-1.7989-2.9058-6.3521-2.9058-6.3521l-.1701-.5706h-3.8702l-.1701.5706s.3993 4.5533-2.9059 6.3521c-.1628.0886-.102.3345.0832.3345h9.8557c.1853 0 .2461-.246.0832-.3345Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.8512 37.4073H18.1493c-.6795 0-1.2302.5509-1.2302 1.2302 0 .6794.5508 1.2301 1.2302 1.2301h11.7019c.6793 0 1.2301-.5508 1.2301-1.2301.0001-.6793-.5508-1.2302-1.2301-1.2302ZM38.1612 9H9.8393c-.67946 0-1.23014.55078-1.23014 1.2301 0 .6794.55078 1.2302 1.23014 1.2302h28.3219c.6794 0 1.2301-.5508 1.2301-1.2302 0-.67932-.5508-1.2301-1.2301-1.2301ZM26.8615 29.883H21.139c-.6795 0-1.2301.5507-1.2301 1.2301 0 .6795.5507 1.2301 1.2301 1.2301h5.7225c.6793 0 1.2301-.5507 1.2301-1.2301.0001-.6794-.5508-1.2301-1.2301-1.2301Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m24.7999 15.324.8575 1.7375c.0639.1295.1583.2414.2751.3263.1168.0849.2525.14.3953.1608l1.9175.2787c.7303.1061 1.022 1.0035.4935 1.5187l-1.3875 1.3525c-.1034.1008-.1807.2252-.2253.3625-.0446.1373-.0552.2834-.0308.4257l.3276 1.9097c.1247.7273-.6388 1.282-1.2921.9387l-1.715-.9017c-.1278-.0672-.27-.1023-.4143-.1023-.1444 0-.2866.0351-.4144.1023l-1.715.9017c-.6532.3434-1.4168-.2114-1.292-.9387l.3276-1.9097c.0244-.1423.0139-.2884-.0308-.4257-.0446-.1373-.1219-.2617-.2253-.3625L19.264 19.346c-.5284-.5151-.2369-1.4126.4934-1.5187l1.9176-.2787c.1428-.0208.2785-.076.3953-.1608.1167-.0849.2111-.1968.275-.3263l.8576-1.7375c.3266-.6618 1.2703-.6618 1.597 0Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
SuccessCup.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "SuccessCup"
};
validateTidalLicense();
export {
  SuccessCup
};
//# sourceMappingURL=SuccessCup.js.map
